import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input
} from "@angular/core";
import { PageToolbarActionGroupComponent } from "src/app/components/ui/page/page-shared/page-toolbar/items/page-toolbar-action-group.component";
import { PageToolbarCardComponent } from "src/app/components/ui/page/page-shared/page-toolbar/items/page-toolbar-card.component";
import { PageToolbarCustomComponent } from "src/app/components/ui/page/page-shared/page-toolbar/items/page-toolbar-custom.component";
import { PageToolbarDateRangeComponent } from "src/app/components/ui/page/page-shared/page-toolbar/items/page-toolbar-daterange.component";
import { PageToolbarGroupComponent } from "src/app/components/ui/page/page-shared/page-toolbar/items/page-toolbar-group.component";
import { PageToolbarSwitchComponent } from "src/app/components/ui/page/page-shared/page-toolbar/items/page-toolbar-switch.component";
import { PageTooolbarItem } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item";
import { PageToolbarItemComponent } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item.component";
import { ButtonClickAsyncEvent } from "src/app/components/ui/button/button-click-async-event";
import {
  IntegrationLayoutAction,
  IntegrationLayoutActionRendered
} from "src/app/integrations/integration-layout";
import { IntegrationService } from "src/app/services/integration.service";

@Component({
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "snoots-page-generic-toolbar",
  templateUrl: "page-generic-toolbar.component.html"
})
export class PageGenericToolbarComponent {
  items = input.required<ReadonlyArray<PageTooolbarItem>>();
  customClass = input<string>("");
  alignItems = input<string>("items-center");

  toolbarIntegrations = input.required<
    Array<{
      title: string;
      icon: string;
      actionsRendered: Array<{
        action: IntegrationLayoutAction;
        rendered: IntegrationLayoutActionRendered;
      }>;
    }>
  >();

  integrationParamsBuilder = input<(() => Record<string, unknown>) | null>(
    null
  );

  child = input<boolean>(false);

  private readonly integrationService = inject(IntegrationService);

  asGroup(item: PageToolbarItemComponent): PageToolbarGroupComponent {
    return <PageToolbarGroupComponent>item;
  }

  asActionGroup(
    item: PageToolbarItemComponent
  ): PageToolbarActionGroupComponent {
    return <PageToolbarActionGroupComponent>item;
  }

  asSwitch(item: PageToolbarItemComponent): PageToolbarSwitchComponent {
    return <PageToolbarSwitchComponent>item;
  }

  asCard(item: PageToolbarItemComponent): PageToolbarCardComponent {
    return <PageToolbarCardComponent>item;
  }

  asCustom(item: PageToolbarItemComponent): PageToolbarCustomComponent {
    return <PageToolbarCustomComponent>item;
  }

  asDateRange(item: PageToolbarItemComponent): PageToolbarDateRangeComponent {
    return <PageToolbarDateRangeComponent>item;
  }

  async toolbarIntegrationItemOnClickAsync(
    buttonClickAsyncEvent: ButtonClickAsyncEvent,
    action: IntegrationLayoutAction
  ): Promise<void> {
    await buttonClickAsyncEvent.execute(async () => {
      await this.integrationService.executeIntegrationAction({
        installation: action.installation!,
        action,
        params: this.integrationParamsBuilder()?.() || {}
      });
    });
  }
}
